import { ProcedureDTO } from "./Procedure.model";

export class SpecialityDTO {
    ID: number;
    Name: string;
    Description: string;
    ImagePath: string;
    ImageBase64: string;
    Procedures: Array<ProcedureDTO>;
    IsActive: boolean;
    IsExpired :boolean;
}

export class AssignedSpecialityDTO {
    ID: number;
    Name: string;
    Description: string;
    ImagePath: string;
    IsChecked: boolean;
}

export class SpecialityMappingDTO {
    Name: string;
    ID: number;
    MySpeciality: boolean;
    IsActive: boolean;
}

export class AnalyticsDataDTO {
    PublicCount:number;
    PrivateCount:number;
    RoleData: Array<RolesDataDTO>;
}

export class RolesDataDTO {
    RoleCategory: string;
    RoleName:string;
    AndroidCount:number;
    IOSCount:number;
}

export class UserRoleDTO {
    PublicCount:number;
    PrivateCount:number;
    RoleData: Array<RolesDataDTO>;
}


// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/Models/Speciality.model.ts